import React, { useCallback } from 'react';
import { FiCopy } from 'react-icons/fi';
import { AnimatedContainer } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import {
  ChangeMethodContainer,
  CopyContainer,
  InstructionsContainer,
  PaymentMethodContainer,
  PixCodeContainer,
  PixKeyWrapper,
  PixQRCodeWrapper,
  PixTitleContainer,
  PixWrapper,
  PlanInfoContainer,
  PlanPriceContainer,
  PriceContainer,
  QRCodeContainer,
  SelectedPaymentMethod,
  SelectedPlanContainer,
  TimerContainer,
} from './styles';
import { PaymentMethodEnum } from '../../../enums/PaymentMethodEnum';
import PixIcon from '../../../assets/pix-icon.svg';
import keyIcon from '../../../assets/key-icon.svg';

import qrCode from '../../../assets/qr-code.svg';

export const PixPayment: React.FC<ComponentUserRegisterProps> = ({
  handleScreenSelection,
  // handlePaymentError,
  nextPage,
}) => {
  const handlePixCopy = useCallback(() => {
    navigator.clipboard.writeText(
      '00020126330014br.gov.bcb.pix01111335366962052040000530398654040.805802BR5919NOME6014CID',
    );

    setTimeout(() => {
      nextPage();
      // handlePaymentError();
    }, 3000);
  }, [nextPage]);

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={3} titles={stepLabels} />
      <h1>Pagar com Pix</h1>
      <SelectedPlanContainer>
        <PlanInfoContainer>
          <span>Assinatura</span>
          <span className="timeFrame">Assistente Virtual</span>
        </PlanInfoContainer>
        <PlanPriceContainer>
          <PriceContainer>
            <span>
              R$ 290,00 <span className="smallText">no Cartão</span>
            </span>
          </PriceContainer>
          <span>Descrição:</span>
          <span className="highlightedText">Assinatura mensal</span>
          <span className="highlightedText">R$ 40,00</span>
          <span>+ R$ 250,00</span>
          <span>Pulseira inteligente</span>
        </PlanPriceContainer>
      </SelectedPlanContainer>
      <PaymentMethodContainer>
        <SelectedPaymentMethod>
          <img src={PixIcon} alt="" />
          <span>Dados PIX</span>
        </SelectedPaymentMethod>
        <ChangeMethodContainer
          onClick={() => handleScreenSelection(PaymentMethodEnum.CreditCard)}
        >
          <span>ALTERAR</span>
        </ChangeMethodContainer>
      </PaymentMethodContainer>
      <PixWrapper>
        <PixKeyWrapper>
          <PixTitleContainer>
            <img src={keyIcon} alt="" />
            <span>Chave</span>
          </PixTitleContainer>
          <PixCodeContainer>
            <div>
              <span>
                00020126330014br.gov.bcb.pix01111335366962052040000530398654040.805802BR5919NOME6014CID
              </span>
            </div>
            <CopyContainer onClick={handlePixCopy}>
              <div>
                <FiCopy />
              </div>
              <span>Copiar</span>
            </CopyContainer>
          </PixCodeContainer>
          <span>CINCO Saúde LTDA</span>
        </PixKeyWrapper>
        <PixQRCodeWrapper>
          <QRCodeContainer>
            <div>
              <img src={qrCode} alt="" />
              <span>QR code</span>
            </div>
            <img src={qrCode} alt="" />
          </QRCodeContainer>
          <TimerContainer>
            <span>
              Tempo restante: <span className="lightTimerText">30 minutos</span>
            </span>
          </TimerContainer>
        </PixQRCodeWrapper>
      </PixWrapper>
      <InstructionsContainer>
        <h1>Instruções para pagamento:</h1>
        <div>
          <span>
            1- Realize o pagamento do valor integral do seu plano para a chave
            PIX informada acima.
          </span>
        </div>
        <div className="middleText">
          <span>
            2- Após concluir o pagamento,{' '}
            <span className="highlighted">anexe o comprovante</span> no campo
            acima
          </span>
        </div>
        <div>
          <span>
            3- Assim que o pagamento for confirmado em nosso sistema, você
            receberá um novo e-mail com a confirmação e os próximos passos do
            seu atendimento .{' '}
          </span>
        </div>
      </InstructionsContainer>
    </AnimatedContainer>
  );
};
